import { JWTBearerClient } from 'rest-resource/dist/client'

export default class HTGAuthClient extends JWTBearerClient {
    negotiateContent(ResourceClass) {
        return (response) => {
            let resources = []

            if (response.data && Array.isArray(response.data.results)) {
                response.data.results.forEach((attributes) => resources.push(new ResourceClass(attributes)))
            } else {
                resources.push(new ResourceClass(response.data))
            }

            return {
                response,
                resources,
            }
        }
    }
}
